<script>
  'use strict'
  import { _centerMap, _autoSaveFile, _borderRadius, _tileCollectionSize } from '../store/store';
  import CustomTheme from './CustomTheme.svelte';

  _borderRadius.subscribe(data => {
    document.documentElement.style.setProperty(`--border-radius`, `${data}px`);
  })

  _tileCollectionSize.subscribe(data => {
    document.documentElement.style.setProperty(`--tile-size`, `${data}px`);
  })
</script>


<div>
  <label for="centerMap">Center Map</label>
  <input type="checkbox" id="centerMap" name="centerMap" bind:checked={$_centerMap}>
  <label for="autoSaveMap">Auto save map { $_autoSaveFile }</label>
  <input type="checkbox" id="autoSaveMap" name="autoSaveMap" bind:checked={$_autoSaveFile}>
  <label for="borderRadius">Border radius</label>
  <input type="range" id="borderRadius" bind:value={$_borderRadius} min="0" max="16">
  <label for="tileCollectionSize">Tile collection size</label>
  <input type="range" id="tileCollectionSize" bind:value={$_tileCollectionSize} min="32" max="128">
  <CustomTheme></CustomTheme>
</div>
